import { getArnParts } from '@iotv/core-services'
import type { StandardProceessEnv, ValidBusinessObject } from '@iotv/iotv-v3-types'
import type { UserAttributeDefs } from '../../types/'
import { ModelCommon } from '../ModelCommon'

const { projectCode, stage } = process.env as StandardProceessEnv

export interface AWSCommonAttributes {
  arn: string
}

const getAWSTypeFromArn = (ob: AWSCommonAttributes) => {
  let type = 'AWSCommmon'
  const arnParts = getArnParts(ob.arn)
  if (arnParts) {
    const { partition, service, region, accountId, resource, instance, suffix1, suffix2, suffix3 } = arnParts
    let Service: string = 'Unknown'
    if (service) {
      Service = service.at(0)?.toUpperCase() + service.slice(1)
    }
    let Resource: string = 'Unknown'
    if (resource) {
      Resource = resource.at(0)?.toUpperCase() + resource.slice(1)
    }

    type = `${Service}${Resource}`
  }
  return type
}

export class AWSCommon extends ModelCommon implements AWSCommonAttributes, ValidBusinessObject {
  constructor({ ...ob }: AWSCommonAttributes) {
    super(getAWSTypeFromArn(ob), { ...ob })
    this.arn = ob.arn

    const arnParts = getArnParts(ob.arn)
    const { partition, service, region, accountId, resource, instance, suffix1, suffix2, suffix3 } = arnParts ?? {}
    const name = instance?.replace(new RegExp(`${projectCode}-${stage}-`), '') ?? 'Unknown'
    const id = instance ?? 'unknown'
    const key = `${this.type}:${id}`
    this.sk = key
    this.pk = key
    this.id = id
    this.name = name
  }

  arn: string
  sk: string
  pk: string
  id: string
  name: string

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      arn: {
        type: 'String',
        editable: false,
      },
    }
  }
}
